import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { GestionSocieteComponent } from './../../../../core/gestion-referentiel/gestion-societe/gestion-societe.component';
import { SocieteModel } from './../../../models/simple-types/societe.model';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, Inject } from '@angular/core';
import { ActiviteModel } from 'src/app/shared/models/simple-types/activite.model';

export interface DialogData {
      form: UntypedFormGroup;
      societes: SocieteModel[];
      activites: ActiviteModel[];
      result: boolean;
    }

@Component({
  selector: 'app-modal-add-societe',
  templateUrl: './modal-add-societe.component.html',
  styleUrls: ['./modal-add-societe.component.scss']
})

export class ModalAddSocieteComponent implements OnInit {
  societes: SocieteModel[];
  form: UntypedFormGroup;
  activite: ActiviteModel;
  constructor(public dialog: MatDialog
    , public dialogRef: MatDialogRef<GestionSocieteComponent>
    , @Inject(MAT_DIALOG_DATA) public data: DialogData
    , private toastr: ToastrService
    , private societeService: SocieteService) {
  }

  ngOnInit(): void {
    this.form = this.data.form;
    if (this.form) {
      this.activite = this.data.activites.find(s => s.id === this.form.get('idActivite').value);
    }
  }

  onChange(activite): void {
    if(activite){
      this.form.get('idActivite').setValue(activite.id);
    } else {
      this.form.get('idActivite').setValue(null);
    }
  }

  onModalCancel(): void {
    this.data.result = false;
    this.dialogRef.close(false);
  }

  onModalConfirm(): void {
    if (this.form.valid) {
      const societe = this.form.getRawValue();
      //this.activite ? societe.idActivite = this.activite.id : societe.idActivite = null;
      societe.activite = null;
      // Création
      if (!this.form.get('id').value){
        const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.societeService.save(societe).subscribe((a: SocieteModel) => {
            this.toastr.success('', 'Création de la société ' + a.code + ' réussie');
            this.dialogRef.close(true);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(true);
            dialogRef.close();
          });
      }else { // Modification
        const dialogRef = this.dialog.open(SpinnerModalComponent);
        this.societeService.update(societe.id, societe).subscribe((a: SocieteModel) => {
          this.toastr.success('', 'Modification de la société ' + a.code + ' réussie');
          this.dialogRef.close(true);
          dialogRef.close();
        }, (error) => {
          this.dialogRef.close(true);
          dialogRef.close();
        });
      }
    } else {
      this.displayErrors();
      this.toastr.warning('', 'Veuillez remplir les champs obligatoire');
    }
  }

  displayErrors(): void {
    for (const index in this.form.controls) {
      if (index) {
         this.form.controls[index].markAsTouched();
      }
    }
  }
}

